exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._3KVJL{cursor:pointer}span._3KVJL,span.o0KM0{font-size:16px;margin:0 8px}._3cCz3{color:#777;font-style:italic}.YCn8O{background:#8b0000;color:#fff;font-weight:700}.YCn8O a{color:#fff!important;text-decoration:underline!important}._3iIk0{background:#f3d8d8;color:#8b0000}.FtMCW{background:#f9fad2}._20I0W{background:#d2e7fa}._35Fw7{padding:0!important}._3js_E{padding:7px;line-height:24px}.BdPDc{padding:7px 3px;line-height:30px}._2iWHv div{overflow-x:hidden!important}._2iWHv div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "_3KVJL",
	"info": "o0KM0",
	"sinSnapshot": "_3cCz3",
	"incumplimiento": "YCn8O",
	"facturaCancelada": "_3iIk0",
	"conCambios": "FtMCW",
	"conActualizaciones": "_20I0W",
	"tdClear": "_35Fw7",
	"field": "_3js_E",
	"fieldAsignacion": "BdPDc",
	"hidden": "_2iWHv"
};